// extracted by mini-css-extract-plugin
export default {"fullScreenLoader":"loader_fullScreenLoader__RfATu"};